import React from "react"
import { View, Image, Text, Modal, Button } from "react-ame-components"
import img from "../assets/images/image_example.jpg"

export class ModalExample extends React.Component {
  state = {
    showModal: false,
    position: "center",
  }
  closeModal = () => {
    this.setState({
      showModal: false,
    })
  }
  openModal = position => {
    this.setState({
      showModal: true,
      position: position,
    })
  }

  render() {
    const { showModal, position } = this.state
    return (
      <View margin="extra-large">
        <Text target="title-large">Modal</Text>
        <View padding="nano">
          <Button
            onClick={() => this.openModal("center")}
            label="Modal centralizado"
            type="primary"
          />
        </View>
        <View padding="nano">
          <Button
            onClick={() => this.openModal("bottom")}
            label="Modal bottom"
            type="secondary"
          />
        </View>

        <Modal
          show={showModal}
          position={position}
          width={position === "center" ? "700px" : "100%"}
          closeModalCallback={this.closeModal}>
          <View
            direction="column"
            align="center"
            justify="center"
            padding="extra-small">
            <Image
              height={200}
              src={img}
            />
            <Text
              target="subtitle-medium"
              textAlign="center">
              Componente Modal
            </Text>
            <View padding="nano">
              <Button
                onClick={() => console.log("Continuar")}
                label="Continuar"
                type="primary"
              />
            </View>
            <View padding="nano">
              <Button
                onClick={() => this.closeModal()}
                label="Cancelar"
                type="secondary"
              />
            </View>
          </View>
        </Modal>
      </View>
    )
  }
}
